module.exports = {
	header: {
		about: 'About',
		game: 'Games',
		contact: 'Contact'
	},
	banner1: {
		logotitle: 'We share the risk with you,',
		logosubtitle: 'we help you make the best game you can.',
		stoketext: 'A Union Of Game Makers'
	},
	banner2: {
		indroduce: 'is an investing & publishing platform that focuses on small-medium sized developers. Our comprehensive system includes support in capital funding, marketing, data analysis, and publishing. In short, we help developers bring their games to the global market.',
		title1: '200+ games published',
		title2: '200M+ downloads',
		title3: '100+ developer partners',
	},
	banner3: {
		slide1: {
			title:'Market Insights',
			desc1: 'Provide data on the latest market trends to understand user preferences of gameplay, themes, art styles etc.',
			desc2: 'Set reasonable targets based on benchmark games and market-based analytics.'
		},
		slide2: {
			title:'Financial Support',
			desc1: 'Provide funds to turn your ideas into a profitable games.',
			desc2: 'We offer flexible methods of funding, including investments, copyright payments, payment in advance etc. '
		},
		slide3: {
			title: 'Feasibility Studies',
			desc1: 'Test core game play and art styles in early stages.',
			desc2: 'Developers provide core gameplay demos and creative aesthetics. In turn, we test them in-market and provide feedback.'
		},
		slide4: {
			title: 'Art Production',
			desc1: 'Our mature insource art team would greatly  enhance art production capacity.',
			desc2: 'Experienced artist could cover all kinds of art styles including realistic, cartoon, comics and etc.'
		},
		stoketext: 'Increase the rate of success'
	},
	banner4: {
		slide1: {
			title:'User Growth',
			desc1: 'Quickly getting the game into the hands of active users through real-time data & alert systems, coupled with dynamic ROI & retention forecasts.',
			desc2: 'Over $100M accumulated through specifically tailored UA campaigns.'
		},
		slide2: {
			title:'Monetization',
			desc1: 'Maximize in-game monetization and user LTV.',
			desc2: 'Perform game lifecycle analysis to adjust monetization strategies with user labeling and segmented optimization.'
		},
		slide3: {
			title: 'Operation & Optimization',
			desc1: 'A data-driven operational approach to achieve sustainable profitability.',
			desc2: 'Accurately predict profitability based on user behavioral analysis.'
		},
		slide4: {
			title: 'Data Intelligence',
			desc1: 'Provide customized game content and experience based on the machine learning.',
			desc2: 'Segment users based on AI model and enhance the monetization efficiency with differentiated strategy.'
		},
		stoketext: 'Enlarge the scale of success'
	},
	banner5: {
		title: 'Our Technology',
		slide1: {
			title: 'Deeply rooted in adept AI',
			desc: 'AI is applied to multiple business channels, including payment prediction, UA, channel management etc. to achieve optimal product performance.'
		},
		slide2: {
			title: 'Dataverse – global  business intelligence platform',
			desc: 'Industry-leading revenue tracking technology which targets and caters toward “high priority” users based on individual spending habits.'
		},
		slide3: {
			title: 'Ad management system',
			desc: 'Intelligent, effective and flexible UA system with real-time data to improve ad impression and conversion.'
		},
		slide4: {
			title: 'Smart creative derivatives platform',
			desc: 'Tracking and applying attractive creatives and ads boosts user conversion by 20%, leading to increased retention. '
		},
		slide5: {
			title: 'Multi-dimensional data pivot and attribution',
			desc: 'Accurately locates inferior channels and creatives to avoid ad fraud, while refining UA effectiveness and reducing costs.'
		},
		slide6: {
			title: 'Real-time data tracking',
			desc: 'Minute-level data analytics and alarm system which pinpoints real-time red flags and avoids catastrophic losses.'
		}
	}
	// banner1: {}
}